import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'bootstrap';
import clientHttp from '../components/ClientHttp';
import { useNavigate } from "react-router-dom";

import RoleList from './RoleList';

export default function RoleContent() {
    const [data, setData] = useState(null);
    const [total, setTotal] = useState(0)
    const [errorMessage, setErrorMessage] = useState(null)
    const [errorMessageClass, setErrorMessageClass] = useState('')
    const [editMessage, setEditMessage] = useState('')
    const [menuMessage, setMenuMessage] = useState('')
    let navigate = useNavigate();

    async function searchSubmit() {
        let isSuccess = false
        // clear data
        setData(null)

        console.log('call get roles api')
        const formData = {}
        let token = localStorage.getItem('token')
        await clientHttp.post('user/v1/role_list', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('display role list')
                setTotal(response.data.total)
                setData(response.data.data)
                isSuccess = true
            }

        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get roles failed: ' + err.message)
            }
        })

    }

    const roleFormRef = useRef(null)
    const menuFormRef = useRef(null)
    useEffect(() => {
        // first enter then call search with current month
        searchSubmit()

        if (roleFormRef.current) {
            roleFormRef.roleFormModal = new Modal(roleFormRef.current, { backdrop: true });
        }
        if (menuFormRef.current) {
            menuFormRef.menuFormModal = new Modal(menuFormRef.current, { backdrop: true });
        }

    }, [roleFormRef, menuFormRef])

    const [roleId, setRoleId] = useState('')
    const [roleName, setRoleName] = useState('')
    const [description, setDescription] = useState('')
    const [roleStatus, setRoleStatus] = useState('')

    async function addRole() {
        console.log('add new role')
        setRoleId(0)
        setRoleName('')
        setDescription('')
        setRoleStatus(true)

        setEditMessage('')
        if (roleFormRef.roleFormModal) roleFormRef.roleFormModal.show()
    }

    async function saveRole() {
        console.log('Save role id: ', roleId)
        setErrorMessageClass('text-danger')
        setEditMessage('')
        let isNewRole = roleId === 0

        // load role
        let token = localStorage.getItem('token')
        const formData = {
            roleId: roleId,
            roleName: roleName,
            description: description,
            status: roleStatus ? 'A' : 'I'
        }
        console.log('form data')
        console.log(formData)

        await clientHttp.post('user/v1/update_role', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            const data = response.data
            console.log('response status: ' + data.status + ', row: ' + data.message)
            if (data.status === 'success') {
                setErrorMessageClass('text-success')
                console.log('update role success')
            } else {
                console.log('update role fail: ' + data.message)
            }

            if (isNewRole) setErrorMessage(data.message)
            else setEditMessage(data.message)
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('save role failed: ' + err.message)
                if (isNewRole) setErrorMessage(err.message)
                else setEditMessage(err.message)
            }
        })

        console.log('Is new role: ' + isNewRole)
        if (isNewRole) {
            // close form and display result popup
            if (roleFormRef.roleFormModal) roleFormRef.roleFormModal.hide()
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        } else {
            // still open form and display result message
        }
    }

    async function editRole(id) {
        console.log('Edit Role id: ' + id)
        let updateResult = false
        setErrorMessageClass('text-danger')
        setErrorMessage('')
        setEditMessage('')

        // load role
        let token = localStorage.getItem('token')
        await clientHttp.get('user/v1/rolebyid', {
            params: { roleId: id },
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            const data = response.data
            console.log('response status: ' + data.status)
            if (data.status === 'success') {
                const role = data.data[0]
                console.log(role)
                setRoleId(role.id)
                setRoleName(role.name)
                setDescription(role.description)
                setRoleStatus(role.status === 'A' ? true : false)

                updateResult = true
            } else {
                console.log('get rolebyid failed: ' + data.message)
                setErrorMessage('Role Id [' + id + '] ' + data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get rolebyid failed: ' + err.message)
                setErrorMessage('Role Id [' + id + '] ' + err.message)
            }
        })

        console.log(updateResult)
        if (!updateResult) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        } else {
            if (roleFormRef.roleFormModal) roleFormRef.roleFormModal.show()
        }
    }

    // Delete user section
    const [deleteRoleName, setDeleteRoleName] = useState(null)
    const [deleteRoleId, setDeleteRoleId] = useState(null)
    const [deleteRoleModal, setDeleteRoleModal] = useState(null)
    async function deleteRole(roleId, roleName) {
        console.log('Delete Role id: ' + roleId + ', name: ' + roleName)
        setDeleteRoleName(roleName)
        setDeleteRoleId(roleId)

        let deleteModal = new Modal('#deleteRoleModal')
        deleteModal.show()
        setDeleteRoleModal(deleteModal)
    }
    async function confirmDeleteRoleHandle() {
        console.log('confirm delete role id ' + deleteRoleId)
        setErrorMessageClass('text-danger')
        setErrorMessage('')

        // load role
        let token = localStorage.getItem('token')
        await clientHttp.post('user/v1/deleterolebyid', { roleId: deleteRoleId }, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            const data = response.data
            console.log('response status: ' + data.status + ', row: ' + data.message)

            if (data.status === 'success') {
                setErrorMessageClass('text-success')
                console.log('delete role success')
            } else {
                console.log('delete role fail: ' + data.message)
            }
            setErrorMessage(data.message)
        }).catch(error => {
            console.log('error: ', error.message)
            if (error.response.status === 401 || error.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('delete role failed: ' + error.message)
                setErrorMessage(data.message)
            }
        })

        // close previous modal
        deleteRoleModal.hide()
        // show result
        let errorMessageModal = new Modal('#errorMessageModal')
        errorMessageModal.show()
    }

    const [isPermissionLoading, setIsPermissionLoading] = useState(false)
    const [menuData, setMenuData] = useState(null)
    const [selectedRole, setSelectedRow] = useState(null)
    const [selectedMenuList, setSelectedMenuList] = useState([])
    const [selectedMenuReadList, setSelectedMenuReadList] = useState([])
    const [selectedMenuUpdateList, setSelectedMenuUpdateList] = useState([])
    let lastMenuGroupName = ''
    async function editMenuPermission(role) {
        let isSuccess = false
        // clear data
        setMenuData(null)
        setErrorMessageClass('text-danger')
        setErrorMessage('')
        setSelectedRow(role)
        setSelectedMenuList([])
        setSelectedMenuReadList([])
        setSelectedMenuUpdateList([])
        console.log('Edit menu permission of role id: ' + role.id)

        // load role
        let token = localStorage.getItem('token')
        await clientHttp.get('user/v1/rolemenubyroleid', {
            params: { roleId: role.id },
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            const data = response.data
            console.log('response status: ' + data.status)
            if (data.status === 'success') {
                setMenuData(data.data)

                // set initial value from db
                let menuSelectedId = []
                let menuReadSelectedId = []
                let menuUpdateSelectedId = []
                data.data.forEach(menu => {
                    if (role.id === menu.roleid) menuSelectedId.push(menu.code)
                    if (menu.readflag === 'Y') menuReadSelectedId.push(menu.code)
                    if (menu.writeflag === 'Y') menuUpdateSelectedId.push(menu.code)
                });
                setSelectedMenuList(menuSelectedId)
                setSelectedMenuReadList(menuReadSelectedId)
                setSelectedMenuUpdateList(menuUpdateSelectedId)
                isSuccess = true
            } else {
                console.log('get menu by role failed: ' + data.message)
                setErrorMessage('Get menu by role failed: ' + data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get menu by role failed: ' + err.message)
                setErrorMessage('Get menu by role failed: ' + err.message)
            }
        })

        console.log(isSuccess)
        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        } else {
            if (menuFormRef.menuFormModal) menuFormRef.menuFormModal.show()
        }

        //console.log(selectedMenuList)
        //console.log(selectedMenuReadList)
        //console.log(selectedMenuUpdateList)
    }
    async function saveMenuPermission() {
        setIsPermissionLoading(true)
        console.log('save menu permission of role: ' + selectedRole.name)
        console.log('Select menu: ' + selectedMenuList)
        console.log('Select read menu: ' + selectedMenuReadList)
        console.log('Select write menu: ' + selectedMenuUpdateList)
        setErrorMessageClass('text-danger')
        setErrorMessage('')

        // load role
        let token = localStorage.getItem('token')
        let formData = {
            roleId: selectedRole.id,
            menuMain: selectedMenuList.join(),
            menuRead: selectedMenuReadList.join(),
            menuUpdate: selectedMenuUpdateList.join()
        }
        await clientHttp.post('user/v1/updaterolemenubyroleid', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            const data = response.data
            console.log('response status: ' + data.status + ', row: ' + data.message)

            if (data.status === 'success') {
                setErrorMessageClass('text-success')
                console.log('Set menu permission success')
            } else {
                console.log('Set menu permission fail: ' + data.message)
            }
            setErrorMessage(data.message)
        }).catch(error => {
            console.log('error: ', error.message)
            if (error.response.status === 401 || error.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('Set menu permission failed: ' + error.message)
                setErrorMessage(data.message)
            }
        })
        setIsPermissionLoading(false)

        // close previous modal
        menuFormRef.menuFormModal.hide()
        // show result
        let errorMessageModal = new Modal('#errorMessageModal')
        errorMessageModal.show()
    }

    function handleMenuPermissionByElement(event, action) {
        const menuEles = document.getElementById("editMenuForm").getElementsByClassName("menuPermissionId");
        const menuReadEles = document.getElementById("editMenuForm").getElementsByClassName("menuPermissionReadId");
        const menuUpdateEles = document.getElementById("editMenuForm").getElementsByClassName("menuPermissionUpdateId");
        let menuSelectedId = []
        let menuReadSelectedId = []
        let menuUpdateSelectedId = []
        if (action === 'view') {
            for (let i = 0; i < menuEles.length; i++) {
                if (menuEles[i].checked) {
                    menuSelectedId.push(menuEles[i].value)

                    menuReadEles[i].checked = true
                }
            }
            for (let i = 0; i < menuReadEles.length; i++) {
                if (menuReadEles[i].checked) {
                    menuReadSelectedId.push(menuReadEles[i].value)
                }
            }

            // send list to parent
            setSelectedMenuList(menuSelectedId)
            setSelectedMenuReadList(menuReadSelectedId)
        } else if (action === 'read') {
            for (let i = 0; i < menuReadEles.length; i++) {
                if (menuReadEles[i].checked) {
                    menuReadSelectedId.push(menuReadEles[i].value)
                }
            }
            setSelectedMenuReadList(menuReadSelectedId)
        } else if (action === 'update') {
            for (let i = 0; i < menuUpdateEles.length; i++) {
                if (menuUpdateEles[i].checked) {
                    menuUpdateSelectedId.push(menuUpdateEles[i].value)
                }
            }
            setSelectedMenuUpdateList(menuUpdateSelectedId)
        }
    }

    return (
        <>
            <div className="page-header">
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="card card-round">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-10"></div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <button type="button" className="btn btn-black btn-border" style={{ "width": "60%" }} onClick={addRole.bind(this)}>
                                            <i className="bi bi-person-circle me-2"></i> Add Role
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <RoleList data={data} editRole={editRole} editMenuPermission={editMenuPermission} deleteRole={deleteRole} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="errorMessageModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <p className={errorMessageClass}><span className="h4">{errorMessage}</span></p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { searchSubmit() }}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div ref={roleFormRef} className="modal fade" id="editRoleForm" tabIndex="-1" aria-labelledby="editRoleFormLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="editRoleFormLabel">Role Form</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label className="col-form-label">Role Id:</label>
                                    <span className="ms-2">{roleId}</span>
                                </div>
                                <div className="mb-3">
                                    <label className="col-form-label">Name:</label>
                                    <input type="text" name="roleName" className="form-control" value={roleName} onChange={e => setRoleName(e.target.value)} />
                                    <label className="col-form-label fs-6">(Max 40 characters)</label>
                                </div>
                                <div className="mb-3">
                                    <label className="col-form-label">Description:</label>
                                    <input type="text" name="description" className="form-control" value={description} onChange={e => setDescription(e.target.value)} />
                                    <label className="col-form-label fs-6">(Max 80 characters)</label>
                                </div>
                                <div className="mb-3">
                                    <input className="form-check-input" type="checkbox" checked={roleStatus} onChange={e => setRoleStatus(e.target.checked)} />
                                    <label className="form-check-label ms-2">Status: {roleStatus ? 'Active' : 'Inactive'}</label>
                                </div>
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6 text-sm">
                                    <span className={errorMessageClass}>{editMessage}</span>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={() => { searchSubmit() }}>Close</button>
                            <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={() => { saveRole() }}>
                                <i className="bi bi-save me-2"></i> Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="deleteRoleModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Delete</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <p className="text-dark">Confirm to delete role: {deleteRoleName}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-danger" onClick={confirmDeleteRoleHandle.bind(this)}>Confirm to delete</button>
                                    <button type="button" className="btn btn-dark" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div ref={menuFormRef} className="modal fade" id="editMenuForm" tabIndex="-1" aria-labelledby="editMenuFormLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="editMenuFormLabel">Menu Permission</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label className="col-form-label h1">Role : </label>
                                    <span className="ms-2">{selectedRole ? selectedRole.name : ''}</span>
                                </div>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col">Menu</th>
                                            <th className="text-center" scope="col">Read</th>
                                            <th className="text-center" scope="col">Update</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            menuData?.map((menu, index) => {
                                                let mgroup = ''
                                                if (lastMenuGroupName !== menu.mgroup) {
                                                    mgroup = menu.mgroup
                                                    lastMenuGroupName = menu.mgroup
                                                }
                                                return (
                                                    <tr key={index}>
                                                        <td>{mgroup}</td>
                                                        <td>
                                                            <input className="me-2 menuPermissionId" type="checkbox" defaultChecked={menu.roleid === selectedRole.id} value={menu.code} onChange={e => { handleMenuPermissionByElement(e, 'view') }} />
                                                            {menu.title}
                                                        </td>
                                                        <td className="text-center">
                                                            <input className="menuPermissionReadId" type="checkbox" defaultChecked={menu.readflag === 'Y'} value={menu.code} onChange={e => { handleMenuPermissionByElement(e, 'read') }} />
                                                        </td>
                                                        <td className="text-center">
                                                            <input className="menuPermissionUpdateId" type="checkbox" defaultChecked={menu.writeflag === 'Y'} value={menu.code} onChange={e => { handleMenuPermissionByElement(e, 'update') }} />
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6 text-sm">
                                    <span className={errorMessageClass}>{editMessage}</span>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal">Close</button>
                            {isPermissionLoading ?
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }}>
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span role="status" className="ms-3">Loading...</span>
                                </button>
                                :
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={() => { saveMenuPermission() }}>
                                    <i className="bi bi-save me-2"></i> Save
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}